import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ProcessHandler from '@src/components/ProcessHandler';
import { LoadingButton } from '@mui/lab';
import { StyledSaveChangeDialog } from './index.style';

const SaveChangeDialog = ({
  maxWidthPx,
  open,
  title,
  description,
  leftButtonMessage,
  rightButtonMessage,
  isLoadingRightButton = false,
  width,
  maxWidth,
  className,
  onClose,
  onHandleLeftButton = () => {},
  onHandleRightButton = () => {},
}) => {
  const isSingleButton = !leftButtonMessage || !rightButtonMessage;

  const [leftLoading, setLeftLoading] = useState(false);

  const handleLeftButton = async () => {
    setLeftLoading(true);
    await onHandleLeftButton();
    setLeftLoading(false);
  };

  return (
    <StyledSaveChangeDialog
      open={open}
      width={width}
      maxWidth={maxWidth || 'xs'}
      fullWidth
      onClose={onClose}
      className={className}
      maxWidthPx={maxWidthPx}
    >
      <Box className="wrapper">
        <Box className="title-wrapper ">
          <Typography className="title-content">{title}</Typography>
        </Box>
        <Box className="content-wrapper">
          <Typography
            className="content"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </Box>
        <Box className={`action ${isSingleButton && 'single'}`}>
          {leftButtonMessage && (
            <LoadingButton
              className="action-button left-button"
              onClick={handleLeftButton}
              variant="outlined"
              loading={leftLoading}
              disabled={leftLoading}
            >
              {leftLoading ? '' : leftButtonMessage}
            </LoadingButton>
          )}
          {rightButtonMessage && (
            <Button
              className="action-button right-button"
              onClick={onHandleRightButton}
              variant="contained"
              color="primary"
            >
              <ProcessHandler
                loading={isLoadingRightButton}
                ml="26px"
                mr="26px"
                size={24}
                align="center"
                color="divider"
              >
                {rightButtonMessage}
              </ProcessHandler>
            </Button>
          )}
        </Box>
      </Box>
    </StyledSaveChangeDialog>
  );
};

export default SaveChangeDialog;
